
<script>
import NewForm from './New'
export default {
  mixins: [NewForm],
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$http
        .get(`consumption-tax-rates/${this.$route.query.id}`)
        .then(res => {
          this.form = res.data
        })
    },
    save() {
      this.$http
        .put(`consumption-tax-rates/${this.$route.query.id}`, this.form)
        .then(() => {
          this.$router.go(-1)
        })
        .catch(this.catch)
    },
    remove() {
      this.$http
        .delete(`consumption-tax-rates/${this.$route.query.id}`)
        .then(() => {
          this.$router.go(-1)
        })
    }
  }
}
</script>
